<app-modal-wrapper [staticHeight]="staticHeight" [modal]="modal">
  <ng-container>
      <h2 class="mortgage-insurance__title">Запрос на продление страхования по ипотеке</h2>

      <p>{{ clientInfo?.name }}</p>
      <small class="mortgage-insurance__text"> Вы получите ответ в течение суток </small>

      <div class="mortgage-insurance__field-success">
        <ion-icon name="custom-success-filled"></ion-icon>
        <span>
          Ваш запрос на продление страхования и расчет стоимости направлен в ООО «Метибер» — страховому агенту банка ПАО
          АКБ «Металлинвестбанк»
        </span>
      </div>

      <ion-button expand="block" class="button primary block" mode="ios" ripple-effect (click)="close()">
        На главную
      </ion-button>
  </ng-container>
</app-modal-wrapper>
